if (!window.__dataClickAnchorBound) {
  window.__dataClickAnchorBound = true;
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-click]');
    if (!trigger) return;
    const id = trigger.getAttribute('data-click');
    if (!id) return;
    e.preventDefault();

    const target = document.getElementById(id);
    if (target) {
      if (target.matches('a, button, [role="button"]')) target.click();
      else target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const anchor = document.createElement('a');
    anchor.href = '#' + id;
    anchor.hidden = true;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  });
}

document.addEventListener("DOMContentLoaded", function () {
  let product = new Swiper(".reward-product-section .swiper-container", {
    grid: {
      fill: "row",
      rows: 2,
    },
    slidesPerView: 2,
    spaceBetween: 10,
    observer: true,
    resizeObserver: true,
    pagination: {
      el: ".reward-product-section .reward-pagination",
      clickable: true,
    },
    breakpoints: {
      1000: {
        slidesPerView: 4,
        spaceBetween: 20,
        navigation: {
          nextEl: ".reward-product-section .reward-arrow-next",
          prevEl: ".reward-product-section .reward-arrow-prev",
        },
        grid:false
      },
    },
  });

  let productRulesOpener = null;

  function closeProductRules() {
    $(".reward-product-section .rules-notice-bg").removeClass("active");
    $(".reward-product-section .rules-notice-bg .rules-notice-box").removeClass("active");
    if (productRulesOpener) productRulesOpener.focus();
  }

  // reward product section点击每个item的rules出现弹窗
  $(".reward-product-section .rules-link").click(function () {
    let link_index = $(this).data("index");
    productRulesOpener = this;
    $(".reward-product-section .rules-notice-bg").addClass("active");
    $(".reward-product-section .rules-notice-bg .rules-notice-box").removeClass("active");
    $(
      `.reward-product-section .rules-notice-bg .rules-notice-box[data-index=${link_index}]`
    ).addClass("active");
    $(".reward-product-section .rules-close-btn").trigger("focus");
  });

  $(".reward-product-section .rules-close-btn").click(function (e) {
    e.stopPropagation();
    closeProductRules();
  });

  $(".reward-product-section .rules-notice-bg").click(function (e) {
    if (e.target === this) closeProductRules();
  });

  $(document).on("keydown.rewardProductRules", function (e) {
    const bg = document.querySelector(".reward-product-section .rules-notice-bg");
    if (!bg || !bg.classList.contains("active")) return;
    if (e.key === "Escape") {
      e.preventDefault();
      closeProductRules();
    }
  });

  function sameHeight(selector) {
    let maxheight = 0;
    $(selector).each(function () {
      if (maxheight < $(this).height()) maxheight = $(this).height();
    });
    $(selector).css({ height: maxheight + 'px' });
  }

  // item 统一高度
  sameHeight(".reward-product-section .reward-coupon-product-box");
  $(window).resize(function () {
    sameHeight(".reward-product-section .reward-coupon-product-box");
  });
});
